import { Fragment } from "react";
import { data } from "./data";
import { NavLink } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { urlDynamic } from "../../../settings/utils/urlDynamic";
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';

export const header = (context) => {

    const RenderMenuItems = ({ items }) => {
        return items.map((item, index) => {
            if (!item.child || item.child.length === 0) {
                return <MenuItem key={index}>
                    <NavLink className='d-block' to={urlDynamic.path.homeFa + item.link}>
                        {item.title}
                    </NavLink>
                </MenuItem>;
            }

            return (
                <SubMenu arrow={false}
                    label={
                        <div className="cPadding8 text-white cFontSize13 fw-normal d-flex justify-content-between align-items-center w-100" style={{ direction: 'rtl' }}>
                            <span>{item.title}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor"
                                className="bi bi-chevron-left ms-3" viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"></path>
                            </svg>
                        </div>
                    }
                    key={index}
                    direction="left"
                    align="start"
                >
                    <RenderMenuItems items={item.child} />
                </SubMenu>
            );
        });
    };

    const currentMenu = context.fCurrentMenu();
    const isLoggedIn = context.state.sIsLoggedIn;

    return (
        <Fragment>
            <div className='row cBg1 cSticky justify-content-center cPx1 py-2'>
                <div className='cContainer col-12'>
                    <div className='row py-2 py-sm-0 align-items-center text-white'>
                        <div className='col-6 col-sm-4 order-2 order-sm-1'>
                            <div className='d-none d-xl-inline-block cCursorPointer cTransition'>
                                <Menu menuButton={
                                    <div className='cHover3 cTransition'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                            fill="currentColor"
                                            className="bi bi-list" viewBox="0 0 16 16">
                                            <path fillRule="evenodd"
                                                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                        </svg>
                                        <span className={`ms-1`}>منو</span>
                                    </div>
                                }>
                                    <RenderMenuItems items={data().menu} />
                                </Menu>
                            </div>

                            <div className='d-inline-block d-xl-none cCursorPointer'
                                onClick={() => context.fOffConvas()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                    fill="currentColor"
                                    className="bi bi-list" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                        d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                                </svg>
                                <span className={`ms-1`}>منو</span>
                            </div>
                        </div>

                        <div className='col-12 mb-4 mb-sm-0 order-1 order-sm-2 col-sm-4 text-center px-sm-0'>
                            <NavLink to={urlDynamic.path.homeFa}>
                                <img src='/images/logo.webp' alt='لوگو' width="250"
                                    height="66"
                                    className=' img-fluid m-auto' />
                            </NavLink>
                        </div>

                        <div className='col-6 col-sm-4 text-end order-3'>
                            <div className='d-flex justify-content-end align-items-center'>

                                {/* جستجو */}
                                <div onClick={() => context.fOffConvas3()}
                                    className='cCursorPointer d-inline-flex align-items-center cHover3 cTransition me-4 cSearchGap'
                                    title="جستجو">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                        fill="currentColor" className="bi bi-search cRotate60 cSearchIcon" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                    </svg>
                                    <span className='ms-1 d-none d-lg-inline'>جستجو</span>
                                </div>

                                {/* جداکننده بین جستجو و دکمه‌های احراز هویت */}
                                <span className='text-white-50 me-4 cDividerGap' style={{ opacity: 0.4 }}>|</span>

                                {/* دکمه‌های احراز هویت */}
                                <div className='d-flex align-items-center gap-3 cFontSize13 cAuthGroup'>

                                    {isLoggedIn ? (
                                        <>
                                            <NavLink to="/profile"
                                                className='text-white text-decoration-none cHover3 cTransition cAuthLink'>
                                                حساب کاربری
                                            </NavLink>

                                            <span className='text-white-50' style={{ opacity: 0.4 }}>|</span>

                                            <button type="button" onClick={() => context.fLogout()}
                                                className='btn btn-link p-0 border-0 text-white text-decoration-none cHover3 cTransition cFontSize13 cAuthLink'>
                                                خروج
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <NavLink to="/login"
                                                className='text-white text-decoration-none cHover3 cTransition cAuthLink'>
                                                ورود
                                            </NavLink>

                                            <span className='text-white-50' style={{ opacity: 0.4 }}>|</span>

                                            <NavLink to="/signup"
                                                className='text-white text-decoration-none cHover3 cTransition cAuthLink'>
                                                ثبت ‌نام دوره
                                            </NavLink>
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Offcanvas منو */}
            <Offcanvas
                backdrop="false"
                className="cZindex9991 d-xl-none border-0"
                show={context.state.sOffConvas}
                onHide={context.fOffConvas}
            >
                <Offcanvas.Header className='cBg2 cColor3 py-3 cBorder6'>
                    <span>{currentMenu.title}</span>

                    <svg
                        onClick={context.fOffConvas}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-x-lg cCursorPointer cColor3"
                        viewBox="0 0 16 16"
                    >
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </Offcanvas.Header>

                <Offcanvas.Body className='cBg2'>

                    {context.state.menuStack.length > 1 && (
                        <div
                            className='d-flex justify-content-end align-items-center px-3 py-2 cCursorPointer cColor7'
                            onClick={context.fBackMenu}>
                            بازگشت
                        </div>
                    )}

                    {currentMenu.items.map(item => {
                        const hasChild = item.child && item.child.length > 0;

                        if (!hasChild) {
                            return (
                                <NavLink
                                    key={item.id}
                                    to={urlDynamic.path.homeFa + item.link}
                                    className='d-flex justify-content-between align-items-center text-white text-decoration-none px-3 py-2'
                                    onClick={context.fOffConvas}
                                >
                                    {item.title}
                                </NavLink>
                            );
                        }

                        return (
                            <div
                                key={item.id}
                                className='d-flex justify-content-between align-items-center text-white px-3 py-2 cCursorPointer'
                                onClick={() => context.fEnterMenu(item)}
                            >
                                <span>{item.title}</span>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    className="bi bi-chevron-left"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                                    />
                                </svg>
                            </div>
                        );
                    })}
                </Offcanvas.Body>
            </Offcanvas>

            {/* Offcanvas جستجو */}
            <Offcanvas backdrop="false" className={`cZindex9991 w-100 bg-dark border-0`}
                show={context.state.sOffConvas3}
                onHide={context.fOffConvas3}>

                <Offcanvas.Header className='text-white py-3 bg-dark'>
                    جستجو
                    <svg onClick={() => context.fOffConvas3()}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20" fill="currentColor"
                        className="bi bi-x-lg cCursorPointer text-white"
                        viewBox="0 0 16 16">
                        <path
                            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    <div className='row cMinHeight align-items-center justify-content-center'>
                        <div className='col-12 col-md-6 col-lg-4 text-center'>

                            <input
                                type='text'
                                autoComplete='off'
                                autoFocus
                                onChange={(e) => context.fSearchInput(e)}
                                defaultValue={context.state.sInputSearch}
                                placeholder='عبارت مورد نظر خود را وارد نمایید'
                                className='form-control form-control-sm text-center bg-transparent cFontSize16_768 cFontSize20 border-0 p-3 text-white'
                                spellCheck="false"

                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        context.fOffConvas3();
                                        document.getElementById("searchBtn").click();
                                    }
                                }}
                            />

                            <NavLink
                                id="searchBtn"
                                to={'/' + urlDynamic.path.search + '?search=' + context.state.sInputSearch}
                                className='rounded cHover6 border-0 py-2 px-3 cCursorPointer mt-2 d-inline-block cBg2 text-white cTransition'>
                                جستجو
                            </NavLink>

                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </Fragment>
    )
}